export default "__VITE_ASSET__B$KQt$ro__"